import React, { useContext } from "react";
import styled from "styled-components";
import { WatchContext } from "../WatchContext";

const Styles = {
  Table: styled.table`
  // font-family: Arial, Helvetica, sans-serif;
  borderCollapse: collapse;
  width: 100%;
  td, th {
    border: 1px solid #ddd;
  padding: 0.8rem;
  }
  tr:nth-child(even){background-color: #ddd;}

  tr:hover {background-color: #f2f2f2;}
 
  th {
   padding-top: 1.2rem;
   padding-bottom: 1.2rem;
   text-align: left;
   background-color: #ddd;
   color: black;
 }
  `,
  TableCont: styled.div`
    width: 725px;
  `,
  Title: styled.span`
    margin: 2rem;
    font-size: 1.4rem;
    font-weight: bold;
  `,
};

const ValuesTable = () => {
  const {
    horizontal,
    vertical,
    hydrology,
    biology,
    vertsed,
    horsed,
    hydrosed,
    biosed,
  } = useContext(WatchContext);

  let topicArray = [
    horizontal,
    vertical,
    biology,
    hydrology,
    vertsed,
    horsed,
    hydrosed,
    biosed,
  ];

  // console.log(vertsed)

  return (
    <Styles.TableCont>
      <Styles.Title>Entered values</Styles.Title>
      <Styles.Table>
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Metric</th>
            <th>Method</th>
            <th>Units</th>
            <th>Current Value</th>
            <th>Reference Low</th>
            <th>Reference High</th>
            <th>Trajectory Low</th>
            <th>Trajectory High</th>
            <th>Forecast Years</th>
          </tr>
        </thead>
        <tbody>
          {topicArray.map((item, i) => (
            <tr key={i}>
              <td>{item.title}</td>
              <td>{item.metric}</td>
              <td>{item.method}</td>
              <td>{item.units}</td>
              <td>
                {item.currentValue}
                
              </td>
              <td>
                {item.criteriaLow}
                
              </td>
              <td>
                {item.criteriaHigh}
                
              </td>
              <td>
                {item.trajectLow}
                
              </td>
              <td>
                {item.trajectHigh}
                
              </td>
              <td>{item.forecastYears}</td>
            </tr>
          ))}
        </tbody>
      </Styles.Table>
    </Styles.TableCont>
  );
};

export default ValuesTable;
